/* Cartes produit Jubylee : carrousel, tailles et coloris.

   Le theme recouvre toute la carte d'un lien invisible qui peut passer
   devant les fleches, les tailles et les pastilles. Plutot que de se
   battre a coups de z-index, on intercepte le clic au niveau du
   document, en phase de capture, et on identifie la cible reelle avec
   elementsFromPoint.

   PRIORITE D'EMPILEMENT
   elementsFromPoint retourne tout ce qui se trouve sous le pointeur, du
   plus haut au plus bas. On retient donc le PREMIER element interessant
   rencontre, et non le premier d'un type donne : sans cela, la petite
   fleche d'une carte, cachee sous le gros bouton du carrousel de
   collection, l'emportait sur lui.

   Les boutons du carrousel de collection (.slider-button) figurent dans
   la liste des cibles uniquement pour pouvoir leur rendre la main : on
   n'intercepte pas leur clic, on laisse le theme le traiter. */

(function () {
  if (window.jubyleeCardInit) return;
  window.jubyleeCardInit = true;

  var CIBLES = '.jbl-card-color, .jbl-gal__fleche, .jbl-card-size, .slider-button';

  function Galerie() {
    return Reflect.construct(HTMLElement, [], Galerie);
  }
  Galerie.prototype = Object.create(HTMLElement.prototype);
  Galerie.prototype.constructor = Galerie;
  Object.setPrototypeOf(Galerie, HTMLElement);

  Galerie.prototype.connectedCallback = function () {
    var self = this;
    this.vues = this.querySelectorAll('.jbl-gal__vue');
    this.index = 0;
    this.glisse = false;
    if (this.vues.length < 2) return;

    var departX = null;

    this.addEventListener('touchstart', function (e) {
      departX = e.changedTouches[0].clientX;
      self.glisse = false;
    }, { passive: true });

    this.addEventListener('touchend', function (e) {
      if (departX === null) return;
      var ecart = e.changedTouches[0].clientX - departX;
      departX = null;
      if (Math.abs(ecart) < 40) return;
      self.glisse = true;
      self.aller(self.index + (ecart < 0 ? 1 : -1));
    }, { passive: true });
  };

  Galerie.prototype.aller = function (n) {
    var total = this.vues.length;
    if (!total) return;
    var cible = (n % total + total) % total;
    this.vues[this.index].classList.remove('is-active');
    this.vues[cible].classList.add('is-active');
    this.index = cible;
  };

  Galerie.prototype.allerVersMedia = function (mediaId) {
    if (!mediaId) return false;
    for (var i = 0; i < this.vues.length; i++) {
      if (this.vues[i].dataset.mediaId === String(mediaId)) {
        this.aller(i);
        return true;
      }
    }
    return false;
  };

  /* Repli : la photo du coloris n'est pas dans le carrousel de la carte.
     On remplace alors la diapositive affichee, pour qu'un clic produise
     toujours un changement visible. */
  Galerie.prototype.remplacerVueActive = function (url) {
    if (!url || !this.vues.length) return false;
    var vue = this.vues[this.index];
    if (!vue) return false;
    vue.removeAttribute('srcset');
    vue.src = url;
    return true;
  };

  if (!window.customElements.get('jbl-card-gallery')) {
    window.customElements.define('jbl-card-gallery', Galerie);
  }

  function cibleReelle(e) {
    var direct = e.target && e.target.closest ? e.target.closest(CIBLES) : null;
    if (direct) return direct;

    if (!document.elementsFromPoint || (!e.clientX && !e.clientY)) return null;

    var pile = document.elementsFromPoint(e.clientX, e.clientY);
    for (var i = 0; i < pile.length; i++) {
      var trouve = pile[i].closest ? pile[i].closest(CIBLES) : null;
      if (trouve) return trouve;
    }
    return null;
  }

  function choisirCouleur(pastille) {
    var groupe = pastille.parentElement;
    if (groupe) {
      groupe.querySelectorAll('.jbl-card-color').forEach(function (autre) {
        autre.classList.remove('is-active');
        autre.setAttribute('aria-pressed', 'false');
      });
    }
    pastille.classList.add('is-active');
    pastille.setAttribute('aria-pressed', 'true');

    var carte = pastille.closest('.card-wrapper');
    if (!carte) return;

    var galerie = carte.querySelector('jbl-card-gallery');

    if (galerie && galerie.allerVersMedia) {
      if (galerie.allerVersMedia(pastille.dataset.mediaId)) return;
      if (galerie.remplacerVueActive(pastille.dataset.image)) return;
    }

    var image = carte.querySelector('.card__media .media img');
    if (image && pastille.dataset.image) {
      image.removeAttribute('srcset');
      image.src = pastille.dataset.image;
    }
  }

  document.addEventListener('click', function (e) {
    var cible = cibleReelle(e);
    if (!cible) return;

    /* Bouton du carrousel de collection : il est au-dessus, il prime.
       On lui rend la main sans rien intercepter. */
    if (cible.classList.contains('slider-button')) return;

    if (cible.classList.contains('jbl-card-color')) {
      e.preventDefault();
      e.stopPropagation();
      choisirCouleur(cible);
      return;
    }

    if (cible.classList.contains('jbl-gal__fleche')) {
      e.preventDefault();
      e.stopPropagation();
      var galerie = cible.closest('jbl-card-gallery');
      if (galerie && galerie.aller) {
        var sens = cible.classList.contains('jbl-gal__fleche--suiv') ? 1 : -1;
        galerie.aller(galerie.index + sens);
      }
      return;
    }

    if (cible.classList.contains('jbl-card-size') && cible.href) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = cible.href;
    }
  }, true);
})();
